import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Home from './home-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Home {...validProps} />;
}
SvgComponent.iconName = 'home';

/**
 * @deprecated This is a legacy icon
 */
export const HomeIcon = svgIconWrapper(SvgComponent);
